module.exports = __webpack_public_path__ + "img/80b274facd0c6c9c513b8ca83ee4188c.png";